module.exports = __webpack_public_path__ + "img/1-1.33dbbc40.svg";